export const FIELD_NAMES = {
    PASSWORD: 'password',
    EMAIL: 'newEmail'
};

export const FIELD_ERRORS = {
    USER_WRONG_PASSWORD: 'Incorrect password. Please try again',
    USER_ALREADY_EXIST: 'This email is already taken. Please try a different email.',
    USER_INVALID_EMAIL: 'This email doesn’t exist. Please try again.'
};
